<template>
    <div>
      <div class="flex mb-4 justify-end items-center p-3">
        <span class="mr-3">Filter Date:</span>
        <date-range-picker
          ref="picker"
          :timePicker="false"
          :showDropdowns="false"
          :max-date="maxDate"
          v-model="dateRange"
          :opens="'left'"
          @update="onChangeDate"
          :auto-apply="true"
        >
          <template v-slot:input="picker" >
            From: {{ moment(picker.startDate) }} - To: {{ moment(picker.endDate) }}
          </template>
        </date-range-picker>
      </div>
      <div class="flex flex-wrap">
        <div class="w-1/4 md:w-1/3 p-3">
          <div class="mb-2 bg-white">
            <div class="card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">
              <div class="m-3">
                <h2 class="text-xs text-left font-bold mb-2 border-b border-black mb-3">Top Subscriber Country</h2>
                <div class="h-300 overflow-y-auto">
                  <ol class="list-outside pl-6" :class="dataTopSubscriberCountry.length>0?'list-decimal':''">
                    <li class="text-center text-sm font-bold text-black p-3" v-if="dataTopSubscriberCountry.length===0">No Data</li>
                    <li class="text-left text-sm font-bold text-black mb-3" v-for="country in dataTopSubscriberCountry" :key="country.name">
                      {{country.name}}<span class="text-xs text-teal-800 float-right">{{country.total}}</span>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-3/4 md:w-2/3 p-3 ">
          <div class="mb-2 bg-white">
            <div class="card cursor-pointer border border-gray-400 rounded-lg">
              <div class="m-3">
                <h2 class="text-xs text-left font-bold mb-2 border-b border-black mb-3">Weekly Subscriber
                  <span class="text-xs text-teal-800 float-right"></span></h2>
                <highcharts class="hc h-300" :options="dataWeeklySubscriber" ref="chart"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
<!--      <div class="flex flex-wrap">-->
<!--        <div class="w-1/4 md:w-1/3 p-3">-->
<!--          <div class="mb-2 bg-white">-->
<!--            <div class="card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">-->
<!--              <div class="m-3">-->
<!--                <h2 class="text-xs text-left font-bold mb-2 border-b border-black mb-3">Top Countries {{ new Date().getFullYear()}}</h2>-->
<!--                <div class="h-300 overflow-y-auto">-->
<!--                  <ol class="list-outside pl-4" :class="dataTopCountry.length>0?'list-decimal':''">-->
<!--                    <li class="text-center text-sm font-bold text-black p-3" v-if="dataTopCountry.length===0">No Data</li>-->
<!--                    <li class="text-left text-sm font-bold text-black mb-3" v-for="country in dataTopCountry" :key="country.country_code">-->
<!--                      {{country.country_name}}<span class="text-xs text-teal-800 float-right">{{country.total}}</span>-->
<!--                    </li>-->
<!--                  </ol>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="w-3/4 md:w-2/3 p-3 ">-->
<!--          <div class="mb-2 bg-white">-->
<!--            <div class="card cursor-pointer border border-gray-400 rounded-lg">-->
<!--              <div class="m-3">-->
<!--                <h2 class="text-xs text-left font-bold mb-2 border-b border-black mb-3">Weekly Customer {{ new Date().getFullYear()}}-->
<!--                  <span class="text-xs text-teal-800 float-right"></span></h2>-->
<!--                <highcharts class="hc h-300" :options="weeklyCustomer" ref="chart"></highcharts>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="flex flex-wrap">
        <div class="w-3/4 md:w-2/3 p-3">
          <div class="mb-2 bg-white">
            <div class="card cursor-pointer border border-gray-400 rounded-lg">
              <div class="m-3">
                <h2 class="text-xs text-left font-bold mb-2 border-b border-black mb-3">Number Songs Sold {{ new Date().getFullYear()}}
                  <span class="text-xs text-teal-800 float-right"></span></h2>
                <highcharts class="hc2 h-300" :options="soldSong"  ref="chart2"></highcharts>
              </div>
            </div>
          </div>

        </div>
        <div class="w-1/4 md:w-1/3  p-3">
          <div class="mb-2 bg-white">
            <div class="card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">
              <div class="m-3">
                <h2 class="text-xs text-left font-bold border-b border-black">Most Popular Song</h2>
                <ul class="flex mb-0 list-none flex-wrap pb-4 flex-row">
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class=" text-xs uppercase px-5 py-3  block leading-normal text-black" v-on:click="toggleTabPopularSong(1)" v-bind:class="{'': popularSongTabIndex !== 1, 'font-bold border-b border-black': popularSongTabIndex === 1}">
                      Lifetime
                    </a>
                  </li>
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class="text-xs uppercase px-5 py-3 block leading-normal text-black" v-on:click="toggleTabPopularSong(2)" v-bind:class="{'': popularSongTabIndex !== 2, 'font-bold border-b border-black': popularSongTabIndex === 2}">
                      Current
                    </a>
                  </li>
                </ul>
                <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-2 overflow-y-auto" style="height: 274px">
                  <div class="flex-auto">
                    <div class="tab-content tab-space px-1">
                      <div v-bind:class="{'hidden': popularSongTabIndex !== 1, 'block': popularSongTabIndex === 1}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularSongLifetime.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularSongLifetime.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularSongLifetime" :key="song.id">
                            {{song.name}}<span class="text-xs text-teal-800 float-right">{{song.total_purchase}}</span>
                          </li>
                        </ol>
                      </div>
                      <div v-bind:class="{'hidden': popularSongTabIndex !== 2, 'block': popularSongTabIndex === 2}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularSongCurrent.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularSongCurrent.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularSongCurrent" :key="song.id">
                            {{song.name}}<span class="text-xs text-teal-800 float-right">{{song.total_purchase}}</span>
                          </li>
                        </ol>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="flex flex-wrap">
        <div class="w-1/4 md:w-1/3 p-3">
          <div class="mb-2 bg-white">
            <div class="card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">
              <div class="m-3">
                <h2 class="text-xs text-left font-bold border-b border-black">Most Popular Album</h2>
                <ul class="flex mb-0 list-none flex-wrap pb-4 flex-row">
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class=" text-xs uppercase px-5 py-3  block leading-normal text-black" v-on:click="toggleTabPopularAlbum(1)" v-bind:class="{'': popularAlbumTabIndex !== 1, 'font-bold border-b border-black': popularAlbumTabIndex === 1}">
                      Lifetime
                    </a>
                  </li>
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class="text-xs uppercase px-5 py-3 block leading-normal text-black" v-on:click="toggleTabPopularAlbum(2)" v-bind:class="{'': popularAlbumTabIndex !== 2, 'font-bold border-b border-black': popularAlbumTabIndex === 2}">
                      Active year
                    </a>
                  </li>
                </ul>
                <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-2 overflow-y-auto" style="height: 274px">
                  <div class="flex-auto">
                    <div class="tab-content tab-space px-1">
                      <div v-bind:class="{'hidden': popularAlbumTabIndex !== 1, 'block': popularAlbumTabIndex === 1}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularAlbumLifetime.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularAlbumLifetime.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularAlbumLifetime" :key="song.id">
                            {{song.name}}<span class="text-xs text-teal-800 float-right">{{song.total_purchase}}</span>
                          </li>
                        </ol>
                      </div>
                      <div v-bind:class="{'hidden': popularAlbumTabIndex !== 2, 'block': popularAlbumTabIndex === 2}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularAlbumCurrent.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularAlbumCurrent.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularAlbumCurrent" :key="song.id">
                            {{song.name}}<span class="text-xs text-teal-800 float-right">{{song.total_purchase}}</span>
                          </li>
                        </ol>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-3/4 md:w-2/3 p-3">
          <div class="mb-2 bg-white">
            <div class="card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">
              <div class="m-3">
                <h2 class="text-xs text-left font-bold mb-2 border-b border-black mb-3">Highest Earning Artist</h2>
                <div class="h-300 overflow-y-auto">
                  <table class="border table-auto w-full">
                    <thead>
                    <tr class="bg-gray-400 text-gray-600 uppercase text-xs leading-normal">
                      <th class="py-3 px-6 text-left">Artist</th>
                      <th class="py-3 px-6 text-left">Album Sold</th>
                      <th class="py-3 px-6 text-left">Single Sold</th>
                      <th class="py-3 px-6 text-left">Total Song Sold</th>
                      <th class="py-3 px-6 text-left">Earning</th>
                    </tr>
                    </thead>
                    <tbody class="text-black text-xs font-light">
                    <tr class="border-b border-gray-200 hover:bg-gray-100" v-for="artist in dataTopEarningArtist" :key="artist.id">
                      <td class="py-3 px-6 text-left">{{artist.name}}</td>
                      <td class="py-3 px-6 text-left">{{artist.total_album}}</td>
                      <td class="py-3 px-6 text-left">{{artist.total_song}}</td>
                      <td class="py-3 px-6 text-left">{{artist.total_song_sold}}</td>
                      <td class="py-3 px-6 text-left">${{!!artist.earning?parseFloat(artist.earning).toFixed(2):0}}</td>
                    </tr>
                    <tr class="border-b border-gray-200 hover:bg-gray-100" v-if="dataTopEarningArtist.length===0">
                      <td class="py-3 px-6 text-center" colspan="4">No Data</td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap">
        <div class="w-1/4 md:w-1/3 p-3">
          <div class="mb-2 bg-white">
            <div class="card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">
              <div class="m-3">
                <h2 class="text-xs text-left font-bold border-b border-black">Most Popular Album By Play</h2>
                <ul class="flex mb-0 list-none flex-wrap pb-4 flex-row">
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class=" text-xs uppercase px-5 py-3  block leading-normal text-black" v-on:click="toggleTabPopularAlbumByPlay(1)" v-bind:class="{'': popularAlbumByPlayTabIndex !== 1, 'font-bold border-b border-black': popularAlbumByPlayTabIndex === 1}">
                      Lifetime
                    </a>
                  </li>
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class="text-xs uppercase px-5 py-3 block leading-normal text-black" v-on:click="toggleTabPopularAlbumByPlay(2)" v-bind:class="{'': popularAlbumByPlayTabIndex !== 2, 'font-bold border-b border-black': popularAlbumByPlayTabIndex === 2}">
                      Active year
                    </a>
                  </li>
                </ul>
                <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-2 overflow-y-auto" style="height: 274px">
                  <div class="flex-auto">
                    <div class="tab-content tab-space px-1">
                      <div v-bind:class="{'hidden': popularAlbumByPlayTabIndex !== 1, 'block': popularAlbumByPlayTabIndex === 1}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularAlbumByPlayLifetime.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularAlbumByPlayLifetime.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularAlbumByPlayLifetime" :key="song.album_id">
                            {{song.name}}<span class="text-xs text-teal-800 float-right">{{song.play_count}}</span>
                          </li>
                        </ol>
                      </div>
                      <div v-bind:class="{'hidden': popularAlbumByPlayTabIndex !== 2, 'block': popularAlbumByPlayTabIndex === 2}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularAlbumByPlayCurrent.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularAlbumByPlayCurrent.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularAlbumByPlayCurrent" :key="song.album_id">
                            {{song.name}}<span class="text-xs text-teal-800 float-right">{{song.play_count}}</span>
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-1/4 md:w-1/3 p-3">
          <div class="mb-2 bg-white">
            <div class="card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">
              <div class="m-3">
                <h2 class="text-xs text-left font-bold border-b border-black">Most Popular Song By Play</h2>
                <ul class="flex mb-0 list-none flex-wrap pb-4 flex-row">
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class=" text-xs uppercase px-5 py-3  block leading-normal text-black" v-on:click="toggleTabPopularSongByPlay(1)" v-bind:class="{'': popularSongByPlayTabIndex !== 1, 'font-bold border-b border-black': popularSongByPlayTabIndex === 1}">
                      Lifetime
                    </a>
                  </li>
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class="text-xs uppercase px-5 py-3 block leading-normal text-black" v-on:click="toggleTabPopularSongByPlay(2)" v-bind:class="{'': popularSongByPlayTabIndex !== 2, 'font-bold border-b border-black': popularSongByPlayTabIndex === 2}">
                      Active year
                    </a>
                  </li>
                </ul>
                <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-2 overflow-y-auto" style="height: 274px">
                  <div class="flex-auto">
                    <div class="tab-content tab-space px-1">
                      <div v-bind:class="{'hidden': popularSongByPlayTabIndex !== 1, 'block': popularSongByPlayTabIndex === 1}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularSongByPlayLifetime.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularSongByPlayLifetime.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularSongByPlayLifetime" :key="song.id">
                            {{song.title}}<span class="text-xs text-teal-800 float-right">{{song.play_count}}</span>
                          </li>
                        </ol>
                      </div>
                      <div v-bind:class="{'hidden': popularSongByPlayTabIndex !== 2, 'block': popularSongByPlayTabIndex === 2}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularSongByPlayCurrent.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularSongByPlayCurrent.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularSongByPlayCurrent" :key="song.id">
                            {{song.title}}<span class="text-xs text-teal-800 float-right">{{song.play_count}}</span>
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { Chart } from 'highcharts-vue';
import { mapActions, mapGetters } from 'vuex';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';

export default {
  name: 'StatisticAdmin',
  props: {
    isLoaded: {
      type: Boolean,
    },
  },
  data() {
    return {
      weeklyCustomer: {
        chart: {
          type: 'area',
        },
        title: false,
        subtitle: false,
        yAxis: {
          title: false,
        },
        xAxis: {
          categories: [],
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">Customer: </td>' +
            '<td style="padding:0"><b>{point.y}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          area: {
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
          },
        },
        series: [{
          name: 'Weeks',
          data: [],
        }],
      },
      soldSong: {
        chart: {
          type: 'column',
        },
        title: false,
        subtitle: false,
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Number of sold',
          },
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">Song: </td>' +
            '<td style="padding:0"><b>{point.y} song</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [{
          name: 'Weeks',
          data: [],

        }],
      },
      dataTopCountry: [],
      popularSongTabIndex: 1,
      dataPopularSongLifetime: [],
      dataPopularSongCurrent: [],
      popularAlbumTabIndex: 1,
      dataPopularAlbumLifetime: [],
      dataPopularAlbumCurrent: [],
      dataTopEarningArtist: [],
      dataTopSubscriberCountry: [],
      popularSongByPlayTabIndex: 1,
      dataPopularSongByPlayLifetime: [],
      dataPopularSongByPlayCurrent: [],
      popularAlbumByPlayTabIndex: 1,
      dataPopularAlbumByPlayLifetime: [],
      dataPopularAlbumByPlayCurrent: [],
      dataWeeklySubscriber: {
        chart: {
          type: 'column',
        },
        title: false,
        subtitle: false,
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Number of subscriber',
          },
        },
        tooltip: {
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
      },
      dateRange: {
        startDate: moment().startOf('year').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      maxDate: moment().format('YYYY-MM-DD'),
      filter: {
        start_date: moment().startOf('year').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
    };
  },
  computed: {
    ...mapGetters('StatisticModule', [
      'listTopCountry', 'listWeeklyCustomer', 'listSoldSong',
      'listPopularSong', 'listPopularSongCurrent',
      'listPopularAlbum', 'listPopularAlbumCurrent',
      'listTopEarningArtist','listTopSubscriberCountry','listWeeklySubscriber',
      'listPopularAlbumByPlay','listPopularAlbumCurrentByPlay',
      'listPopularSongByPlay','listPopularSongCurrentByPlay',
    ]),
  },
  watch: {
    isLoaded: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.requestListTopCountry();
        await this.requestListWeeklyCustomer();
        await this.requestListSoldSong();
        await this.requestListPopularSong();
        await this.requestListPopularAlbum();
        await this.requestListTopEarningArtist();
        await this.requestTopSubscriberCountry(this.filter);
        await this.requestWeeklySubscriber(this.filter);
        await this.requestPopularSongByPlay();
        await this.requestPopularAlbumByPlay();
      },
    },
    listTopCountry: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataTopCountry = val.data;
        }
      },
    },
    listPopularSong: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataPopularSongLifetime = val.data;
        }
      },
    },
    listPopularSongCurrent: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataPopularSongCurrent = val.data;
        }
      },
    },
    listPopularAlbum: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataPopularAlbumLifetime = val.data;
        }
      },
    },
    listPopularAlbumCurrent: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataPopularAlbumCurrent = val.data;
        }
      },
    },
    listWeeklyCustomer: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data !== undefined) {
          if (val.data.length > 0) {
            const dataSeries = [];
            const dataWeek = [];
            let maxWeek = 0;
            const categories = [];
            val.data.forEach((week) => {
              const weekData = week.week.split(' ');
              const weekNumber = parseInt(weekData[1]);
              dataWeek[weekNumber - 1] = week.total;
              maxWeek = weekNumber > maxWeek ? weekNumber : maxWeek;
            });
            for (let i = 0; i <= maxWeek - 1; i++) {
              categories.push(`Week ${i + 1}`);
              dataSeries.push(dataWeek[i] !== undefined ? dataWeek[i] : 0);
            }
            this.weeklyCustomer.xAxis.categories = categories;
            this.weeklyCustomer.series[0].data = dataSeries;
          }
        }
      },
    },
    listSoldSong: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data !== undefined) {
          if (val.data.length > 0) {
            const dataSeries = [];
            const dataWeek = [];
            let maxWeek = 0;
            const categories = [];
            val.data.forEach((week) => {
              const weekData = week.week.split(' ');
              const weekNumber = parseInt(weekData[1]);
              dataWeek[weekNumber - 1] = week.total;
              maxWeek = weekNumber > maxWeek ? weekNumber : maxWeek;
            });
            for (let i = 0; i <= maxWeek - 1; i++) {
              categories.push(`Week ${i + 1}`);
              dataSeries.push(dataWeek[i] !== undefined ? dataWeek[i] : 0);
            }
            this.soldSong.xAxis.categories = categories;
            this.soldSong.series[0].data = dataSeries;
          }
        }
      },
    },
    listTopEarningArtist: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataTopEarningArtist = val.data;
        }
      },
    },
    listTopSubscriberCountry: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataTopSubscriberCountry = val.data;
        }
      },
    },
    listWeeklySubscriber: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data !== undefined) {
          if (val.data.length > 0) {
            const dataSeries = [{
              name: 'Recurring',
              data: [],
            },{
              name: 'One Time',
              data: [],
            }];
            const dataWeek = [];
            let maxWeek = 0;
            const categories = [];
            val.data.forEach((week) => {
              const weekData = week.week.split(' ');
              const weekNumber = parseInt(weekData[1]);
              dataWeek[weekNumber - 1] = [week.recurring, week.one_time];
              maxWeek = weekNumber > maxWeek ? weekNumber : maxWeek;
            });
            for (let i = 0; i <= maxWeek - 1; i++) {
              categories.push(`Week ${i + 1}`);
              if(dataWeek[i] !== undefined){
                dataSeries[0].data.push(dataWeek[i][0]);
                dataSeries[1].data.push(dataWeek[i][1]);
              }

            }
            this.dataWeeklySubscriber.xAxis.categories = categories;
            this.dataWeeklySubscriber.series = dataSeries;
          }
        }
      },
    },
    listPopularAlbumByPlay: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        this.dataPopularAlbumByPlayLifetime = val;
      },
    },
    listPopularAlbumCurrentByPlay: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        this.dataPopularAlbumByPlayCurrent = val;
      },
    },
    listPopularSongByPlay: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        this.dataPopularSongByPlayLifetime = val;
      },
    },
    listPopularSongCurrentByPlay: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        this.dataPopularSongByPlayCurrent = val;
      },
    },
  },
  methods: {
    ...mapActions('StatisticModule', ['requestListTopCountry', 'requestListWeeklyCustomer', 'requestListSoldSong',
      'requestListPopularSong', 'requestListPopularAlbum', 'requestListTopEarningArtist',
      'requestTopSubscriberCountry', 'requestWeeklySubscriber','requestPopularSongByPlay','requestPopularAlbumByPlay'
    ]),
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        start_date: moment(res.startDate).format('YYYY-MM-DD'),
        end_date: moment(res.endDate).format('YYYY-MM-DD'),
      };
      await this.requestWeeklySubscriber(this.filter);
      await this.requestTopSubscriberCountry(this.filter);
    },
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    toggleTabPopularSong(tabNumber) {
      this.popularSongTabIndex = tabNumber;
    },
    toggleTabPopularAlbum(tabNumber) {
      this.popularAlbumTabIndex = tabNumber;
    },
    toggleTabPopularSongByPlay(tabNumber) {
      this.popularSongByPlayTabIndex = tabNumber;
    },
    toggleTabPopularAlbumByPlay(tabNumber) {
      this.popularAlbumByPlayTabIndex = tabNumber;
    },
  },
  components: {
    highcharts: Chart,
    DateRangePicker
  },
};
</script>
<style scoped>
.count-listener{
  font-size: 36px;
}
.hc{
  width:100%;
}
.min-h-400{
  min-height: 400px;
}
.h-400{
  height: 400px;
  overflow-y: auto;
}
.h-300{
  height: 320px;
}
.overflow-y-auto{
  overflow-y: auto;
}
</style>
<style>
.reportrange-text{
  padding: 13px 10px !important;
  height: 50px;
  font-size: 14px !important;
}
.daterangepicker .calendars{
  display:flex !important;
}
</style>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
.vue-daterange-picker .reportrange-text{
  padding: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Statistic/Admin.vue